import { Controller } from 'react-hook-form';
import {
  Message,
  SearchableSelect,
  Select
} from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import { isEmpty, pluck, prop } from 'ramda';
import hasError from './helpers/hasError';
import handleValidationIndicator from '@@viewCommonComponents/controlled/helpers/handleValidationIndicator.js';
import { useEffect } from 'react';

const ControlledSelect = ({
  name,
  form,
  multi = false,
  rules,
  label,
  tooltip = '',
  options = [],
  containerClassName = '',
  withIndicator = true,
  extraChange = () => {},
  isDisplayed = true,
  isSearchable = false,
  shouldUnregister = false,
  recommendedValue,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }

  // Search
  const SelectComponent = isSearchable ? SearchableSelect : Select;
  const $label = prop('required', rules) ? `${label} *` : label;

  if (isEmpty(options)) {
    return null;
  }

  useEffect(() => {
    form.trigger();
  }, []);

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <Controller
        name={name}
        defaultValue={multi ? [] : ''}
        control={form.control}
        rules={rules}
        shouldUnregister={shouldUnregister}
        render={(props) => {
          return (
            <SelectComponent
              tooltip={tooltip}
              label={$label}
              withIndicator={withIndicator}
              error={handleValidationIndicator(
                props.field.value,
                rules,
                getErrorMessage(form.formState.errors, name)
              )}
              {...props}
              {...props.field}
              options={options}
              recommendedValue={recommendedValue}
              onChange={(event) => {
                if (multi) {
                  props.field.onChange(pluck('value', event.target));
                } else {
                  props.field.onChange(event.target.value);
                }

                extraChange(event.target.value);
              }}
              value={
                rules.validate(props.field.value) === true
                  ? props.field.value
                  : ''
              }
              {...extraProps}
              className={
                hasError(form.formState.errors, name) ? 'border-red-500' : ''
              }
            />
          );
        }}
      />
      <Message
        variant="error"
        label={getErrorMessage(form.formState.errors, name)}
      />
    </div>
  );
};

export default ControlledSelect;
